import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { Link, Divider, Text } from '@paypalcorp/pp-react';
import '../../utility/csrf';
import CharityLogo from '../../components/CharityLogo';
import AmountWrapper from '../../components/amountWrapper';
import SubHeader from '../../components/subHeader';
import NextButton from '../../components/nextButton';
import OneTouchNextButton from '../../components/landing/OneTouchNextButton';
import CancelAndReturn from '../../components/cancelAndReturn';
import GuestButton from '../../components/guestButton';
import RecurringCheckBox from '../../components/recurring-checkbox/recurring-checkbox';
import UserDetailsBanner from '../../components/onetouch/UserDetailsBanner';
import OfferDetail from '../../components/offerDetail';
import VoucherFlowDisclaimer from '../../components/voucherFlowDisclaimer';
import ReceiverEligibilityErrorTile from '../error/receiverEligibilityError';

import templateData from '../../utility/getTemplateData';

import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import * as cpl from '../../utility/cpl';

import {
  handleLogIn,
  addShake,
  handleTokenReuse,
  hideSpinnerOverlay,
  validateDonationAmountForUS,
  getPPCCStatus,
} from '../../utility/helper';
import {
  isOneTouchUser,
  isAuthenticatedUser,
  shouldShowUserBanner,
  isLoggedInUser,
} from '../../utility/authUtils';
import * as amountUtils from '../../components/amount/amountUtils';

import { withRouter } from 'react-router-dom';
import * as FPT from '../../utility/fpt';
import {
  localsMessages,
  isMobileHeaderExp,
  isOldButtonFactory,
  isPartnerFlow,
  hasPartnerSource,
} from '../../utility/getTemplateData';
import { loadBodyMovin } from '../../utility/lazyLoader';
import _isEmpty from 'lodash/isEmpty';
import ProgramsContainer from '../../components/programs/ProgramsContainer';
import { showLanguageSelector } from '../../utility/languageSelector';
import RecurringOverlay from '../../components/recurring-checkbox/RecurringOverlay';
import _get from 'lodash/get';
import NotTaxDeductibleLegalText from '../../components/NotTaxDeductibleLegalText';
import { getParameterByName } from '../../utility/queryStringHelper';

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('errors/landingerror');
const MERCHANT_PPCC_CONFIRMED_STATUS = 'Confirmed';

let currentState = templateData.currentState;

class LandingPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLogo: templateData.hasLogo,
      subHeaderLabel: templateData.donationName,
      orgName: templateData.charityName,
      donationId: templateData.donationId,
      guestRedirectUrl: templateData.guestRedirectUrl,
      donateDisabled: false,
      recurringEnabled: templateData.recurringEnabled,
      recurringStatus: templateData.recurringStatus === 'checked',
      recurringHelpText: '',
      recurringLabel: 'Make this a monthly donation',
      rpContinue: false,
      isAuthenticated: isAuthenticatedUser(),
      memberMandatory: templateData.memberMandatory,
      programNames: templateData.donateContext.program_names,
      isRecurringOverlayOpen: false,
      isVoucherFlow: templateData.isVoucherFlow,
      offerProgram: templateData.offerProgram,
    };
  }

  getPPCCConfirmation() {
    return getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS;
  }

  componentDidMount() {
    window.onload = function () {
      setTimeout(function () {
        cpl.logPerformance({
          action: 'landing_page_loaded',
          uicomp: 'landingPageComponent',
          uitype: 'page',
          page: 'main:donate:wps::landing:landingPageComponent:web::',
        });
      }, 0);
    };

    AppActions.updateCurrentPage({ currentPage: 'landing' });
    hideSpinnerOverlay();

    // Checking for recurring status if coming from guest page
    if (AppStore.getDonationRecurring() === 'checked') {
      this.setState({ recurringStatus: true });
    }

    // Pre-load bodyMovin
    if (templateData.recurringEnabled) {
      loadBodyMovin();
    }

    if (!isLoggedInUser()) {
      showLanguageSelector();
    }

    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();
  }

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  registerAppDispatcherMessages() {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_RECURRING') {
        const checked = _get(payload.action, 'item', 'unchecked');
        this.setState({
          recurringStatus: checked === 'checked',
        });
      }
    });
  }

  getFPTDATA = () => {
    return {
      amount: AppStore.getDonationAmount(),
      code: AppStore.getDonationCode(),
      symbol: AppStore.getDonationSymbol(),
    };
  };

  validateAmountAndNavigateToGuestPage = () => {
    let donationAmount = AppStore.getDonationAmount();

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      this.props.history.push(`/donate/guest?token=${templateData.token}`);
    } else {
      addShake();
    }
  };

  handleGuest = (event) => {
    event.preventDefault();
    AppActions.changeRecurringModalStatus({
      recurringModalStatus: 'notclosed',
    });
    let donationAmount = AppStore.getDonationAmount();
    let handleGuestObj = this;
    if (!this.validateDonationAmount()) {
      return;
    }

    if (!amountUtils.isAmountGreaterThanZero(donationAmount)) {
      addShake();
      return;
    }

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      const isRecurringChecked = this.state.recurringStatus;

      if (isRecurringChecked && !this.state.memberMandatory) {
        this.openRecurringOverlay();
      } else {
        this.validateAmountAndNavigateToGuestPage();
      }
      // Tracking click event with data. 'Pay by card with amount'
      FPT.trackLinkClick('donateWithCard');

      // Start CPL tracking to get measurements to load guest form
      window.PAYPAL.analytics.startCPLTracking({
        page: 'main:donate:wps:guest:guestform:guestFormComponent:web::',
        action: 'guest_form_loaded',
        uicomp: 'guestForm',
        uitype: 'component',
      });
    }
  };

  handleNext = (event) => {
    event.preventDefault();
    if (!this.validateDonationAmount()) {
      return;
    }

    let donationAmount = AppStore.getDonationAmount();
    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      FPT.trackLinkClick('donateWithPayPal');
    }
    FPT.addDonationAmount(donationAmount, window.fpti.pgrp, window.fpti.page);

    handleLogIn();
  };

  displayValidationError = () => {
    const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
    this.setState({
      showValidationError: true,
      validationErrorMessage: errorMessage,
    });
    addShake();
  };

  hideValidationError = () => {
    this.setState({
      showValidationError: false,
    });
  };

  validateDonationAmount = () => {
    if (templateData.donationCode === 'USD') {
      if (validateDonationAmountForUS()) {
        this.setState({
          showValidationError: false,
          validationErrorMessage: '',
        });
        return true;
      }
      this.displayValidationError();
      return false;
    } else {
      if (!amountUtils.isAmountGreaterThanZero(AppStore.getDonationAmount())) {
        this.setState({
          showValidationError: true,
          validationErrorMessage: messages.error.amount,
        });
        addShake();
        return false;
      }
    }
    return true;
  };

  handleAmountFocus = () => {
    if (this.state.showValidationError) {
      this.hideValidationError();
    }
  };

  updateConversionSataus = (status = false) => {
    this.setState({ donateDisabled: status });
  };

  handleRecurringChange = (status = false) => {
    this.setState({ recurringStatus: status });
    console.log('status ', status);
  };

  handleRecurringOverlayContinue = () => {
    this.setState({ rpContinue: true });
    this.validateAmountAndNavigateToGuestPage();
  };

  handleRecurringOverlayMakeOneTimeDonation = () => {
    AppActions.changeRecurring({
      recurring: 'unchecked',
    });
    this.validateAmountAndNavigateToGuestPage();
  };

  openRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: true,
    });
  };

  closeRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: false,
    });
  };

  renderProgramsDropdown = () => {
    if (isOldButtonFactory() || _isEmpty(this.state.programNames)) {
      return null;
    }

    return <ProgramsContainer programNames={this.state.programNames} />;
  };

  render() {
    const showUserBanner = shouldShowUserBanner();

    if (!templateData.receiverCountryEligible) {
      return (
        <div
          className={`donate_wrapper receiver-eligibility-error-container ${
            isMobileHeaderExp() ? 'mobile_view' : ''
          }`}
        >
          <ReceiverEligibilityErrorTile
            errorMessages={errorMessages}
            organizationName={templateData.donationName}
            returnUrl={templateData.charityReturnUrl}
          />
        </div>
      );
    }

    return (
      <div>
        <div
          className={`donate_wrapper ${showUserBanner ? 'user-banner' : ''} ${
            isMobileHeaderExp() ? 'mobile_view' : ''
          }`}
        >
          <div className="container">
            {showUserBanner ? (
              <UserDetailsBanner userDetails={templateData.userDetails} />
            ) : null}
            {this.state.hasLogo ? <CharityLogo /> : null}
            <SubHeader
              donationId={this.state.donationId}
              orgName={this.state.orgName}
              label={this.state.subHeaderLabel}
              page="landing"
            />
            <AmountWrapper
              conversionStatus={this.updateConversionSataus}
              validateDonationAmount={this.validateDonationAmount}
              showValidationError={this.state.showValidationError}
              hideValidationError={this.hideValidationError}
              validationErrorMessage={this.state.validationErrorMessage}
              onFocus={this.handleAmountFocus}
            />
            {this.renderProgramsDropdown()}
            {this.state.recurringEnabled && (
              <RecurringCheckBox
                status={this.state.recurringStatus}
                handleChange={this.handleRecurringChange}
                showNote={false}
                hasRecurringHelp={true}
                continue={this.state.rpContinue}
              />
            )}
            {this.state.isVoucherFlow && (
              <OfferDetail
                offerProgram={this.state.offerProgram}
                success={false}
              />
            )}
            {this.state.isAuthenticated ? (
              <div className="ppvx_row">
                <OneTouchNextButton
                  disabled={this.state.donateDisabled}
                  handleNext={this.handleNext}
                />
              </div>
            ) : (
              <div>
                <div className="ppvx_row mb-16">
                  <NextButton
                    disabled={this.state.donateDisabled}
                    handleNext={this.handleNext}
                  />
                </div>
                <div className="ppvx_row">
                  <GuestButton
                    disabled={this.state.donateDisabled}
                    handleGuest={this.handleGuest}
                  />
                </div>
              </div>
            )}
            {this.state.isVoucherFlow && <VoucherFlowDisclaimer />}
            {hasPartnerSource() &&
              !this.getPPCCConfirmation() &&
              !this.state.isVoucherFlow && <NotTaxDeductibleLegalText />}
            {!isPartnerFlow() && <CancelAndReturn />}
            {/* this.state.isVoucherFlow &&
							<>
								<Divider secondary style={{maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto'}}/>
								<div className="ppvx_row ppvx_justify-content-center">
									<Link href="#">{partnerMessages.voucher.howToRedeem}</Link>
								</div>
							</>
						*/}
            <RecurringOverlay
              onContinue={this.handleRecurringOverlayContinue}
              onMakeOneTimeDonation={
                this.handleRecurringOverlayMakeOneTimeDonation
              }
              isOpen={this.state.isRecurringOverlayOpen}
              openRecurringOverlay={this.openRecurringOverlay}
              closeRecurringOverlay={this.closeRecurringOverlay}
            />
          </div>
        </div>
        {isPartnerFlow() && <CancelAndReturn />}
      </div>
    );
  }
}

const LandingPage = withRouter(LandingPageComponent);

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayLanding: currentState ? false : true,
    };
  }

  /**
   * For DIRECT(nonWebscr) and POST integrations, there will not be a token in the URL
   * This will break page refresh.
   * Hence adding token here
   */
  addTokenToUrlIfMissing() {
    const token = getParameterByName('token');
    const business = getParameterByName('business');
    const hostedButtonId = getParameterByName('hosted_button_id');

    if (!token && !business && !hostedButtonId) {
      this.props.history.replace({
        pathname: '/donate',
        search: `?token=${templateData.token}`,
      });
    }
  }

  componentDidMount() {
    if (currentState) {
      this.props.history.push(currentState);
    } else {
      handleTokenReuse();
    }
    this.addTokenToUrlIfMissing();
  }

  render() {
    return <div>{this.state.displayLanding ? <LandingPage /> : null}</div>;
  }
}

export default withRouter(Landing);
